"use client";

/**
 * The one thing EVERY mount of the trial → Pro convert modal must do when
 * `onConverted` fires: start the entitlement sync AND surface the post-upgrade
 * confirmation.
 *
 * TrialExhaustedModal is mounted three times — the builder page, the app-wide
 * <TrialConvertHost/>, and Settings → Billing — and each mount used to hand-roll
 * its own `onConverted`. Only the builder page's copy showed the confirmation,
 * so a user who upgraded from any out-of-credits CTA (which all route through
 * the host) paid $29 and watched the modal simply close: the reported
 * missing-confirmation bug. Same drift class syncEntitlementUntilSettled was
 * extracted to kill; this closes the confirmation half of it. Mounts keep only
 * what is genuinely theirs (closing their own modal state, page-local counter
 * refreshes) and delegate the rest here.
 */

import { showPurchaseConfirmation } from "@/components/billing/purchase-confirmation-store";
import { trialConvertConfirmationInput } from "@/lib/billing/checkout-return";
import { syncEntitlementUntilSettled } from "@/lib/billing/entitlement-refresh";

export function trialConversionCompleted(args?: {
  /** Project the user was building when they hit the paywall, when known —
   *  carried onto the confirmation so its analytics keep the build context. */
  projectId?: string | null;
}) {
  // The $29 has settled, but the trial → Pro flip is finished ASYNCHRONOUSLY by
  // the invoice.payment_succeeded webhook — a single re-read can come back
  // still trialing. This shared, single-flight poll keeps re-reading and
  // re-broadcasting until the authoritative Pro state is in hand, so the
  // billing card, the trial banner and the nav chip converge together.
  void syncEntitlementUntilSettled();
  // The early convert is in-app with no checkout redirect, so no
  // checkout-return path can fire the confirmation — this call is the only
  // place the user is ever told the upgrade worked ("Welcome to Pro").
  showPurchaseConfirmation(
    trialConvertConfirmationInput({
      source: "trial_convert",
      projectId: args?.projectId ?? null,
    }),
  );
}
